module.exports = __webpack_public_path__ + "adyen-logo.168cd9369b4d0f8f89df31694f5a0de9.svg";